import { render, staticRenderFns } from "./sinoceanView.vue?vue&type=template&id=020d66b6&scoped=true"
import script from "./sinoceanView.vue?vue&type=script&lang=js"
export * from "./sinoceanView.vue?vue&type=script&lang=js"
import style0 from "./sinoceanView.vue?vue&type=style&index=0&id=020d66b6&prod&lang=less&scoped=true"
import style1 from "./sinoceanView.vue?vue&type=style&index=1&id=020d66b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020d66b6",
  null
  
)

export default component.exports